export const hlJPz = {
  home: {
    title1: 'すごいタイトル1',
    title2: 'すごいタイトル2'
  },
  i01r: {
    i01r_0001s: {
      fml: 'プロジェクトID',
      aan: 'ID'
    },
  },
}
